import type { TripDashboardNotificationsResponse } from "../../hooks/react-query/linehaul/useTripsDashboardAlerts";

export const mockTripDashboardNotifications: TripDashboardNotificationsResponse =
  {
    notifications: {
      new: [
        {
          id: 288,
          tripNumber: 10027660,
          originSic: {
            id: 103,
            code: "ATB-SEFL",
            ownership: "V",
            lhRegionId: 3,
            timeZone: "America/New_York",
          },
          destinationSic: {
            id: 2,
            code: "LAX",
            ownership: "C",
            lhRegionId: 5,
            timeZone: "America/Los_Angeles",
          },
          stops: ["AFW", "ONT"],
          notificationType: "TrackedInSameAreaForAtLeastTwoHours",
          readStatus: false,
          createdById: "5864ddf3-66e0-4cb7-9fdf-aa4828d6abba",
          createdBy: "Nandini Peddinti",
          createdOn: new Date("2026-02-11T10:15:22.123456Z"),
          modifiedById: null,
          modifiedBy: "",
          modifiedOn: null,
          notificationIcon: "Error",
        },
        {
          id: 287,
          tripNumber: 10027945,
          originSic: {
            id: 115,
            code: "HTX",
            ownership: "C",
            lhRegionId: 3,
            timeZone: "America/Chicago",
          },
          destinationSic: {
            id: 2,
            code: "LAX",
            ownership: "C",
            lhRegionId: 5,
            timeZone: "America/Los_Angeles",
          },
          stops: [],
          notificationType: "MechanicalStatus",
          readStatus: false,
          createdById: "1feeeba1-edcd-49a9-9b55-c5d074f1d1dc",
          createdBy: "Unknown",
          createdOn: new Date("2026-02-11T09:42:10.654321Z"),
          modifiedById: null,
          modifiedBy: "",
          modifiedOn: null,
          notificationIcon: "Warning",
        },
        {
          id: 286,
          tripNumber: 10027295,
          originSic: {
            id: 174,
            code: "ABE",
            ownership: "V",
            lhRegionId: null,
            timeZone: "America/New_York",
          },
          destinationSic: {
            id: 82,
            code: "ATC",
            ownership: "V",
            lhRegionId: null,
            timeZone: "America/New_York",
          },
          stops: [],
          notificationType: "TrackedInSameAreaForAtLeastTwoHours",
          readStatus: false,
          createdById: "b0e94ef6-884a-4714-90ab-c61582e2df41",
          createdBy: "Yamuna Kotla",
          createdOn: new Date("2026-02-11T08:30:00.000000Z"),
          modifiedById: null,
          modifiedBy: "",
          modifiedOn: null,
          notificationIcon: "Warning",
        },
      ],
      older: [
        {
          id: 285,
          tripNumber: 10027658,
          originSic: {
            id: 103,
            code: "ATB-SEFL",
            ownership: "V",
            lhRegionId: 3,
            timeZone: "America/New_York",
          },
          destinationSic: {
            id: 2,
            code: "LAX",
            ownership: "C",
            lhRegionId: 5,
            timeZone: "America/Los_Angeles",
          },
          stops: ["ATC", "ONT", "VIS"],
          notificationType: "TrackedInSameAreaForAtLeastTwoHours",
          readStatus: false,
          createdById: "5864ddf3-66e0-4cb7-9fdf-aa4828d6abba",
          createdBy: "Nandini Peddinti",
          createdOn: new Date("2026-02-10T18:06:39.517369Z"),
          modifiedById: null,
          modifiedBy: "",
          modifiedOn: null,
          notificationIcon: "Error",
        },
        {
          id: 284,
          tripNumber: 10028145,
          originSic: {
            id: 168,
            code: "CLE-PITD",
            ownership: "V",
            lhRegionId: 4,
            timeZone: "America/New_York",
          },
          destinationSic: {
            id: 2,
            code: "LAX",
            ownership: "C",
            lhRegionId: 5,
            timeZone: "America/Los_Angeles",
          },
          stops: ["ONT"],
          notificationType: "TrackedInSameAreaForAtLeastTwoHours",
          readStatus: true,
          createdById: "1f6d2a26-04e0-4587-9312-a0b0dc0bbfb6",
          createdBy: "Usharani Modhipalli",
          createdOn: new Date("2026-02-09T17:17:40.585942Z"),
          modifiedById: null,
          modifiedBy: "",
          modifiedOn: null,
          notificationIcon: "Error",
        },
        {
          id: 283,
          tripNumber: 10027693,
          originSic: {
            id: 174,
            code: "ABE",
            ownership: "V",
            lhRegionId: null,
            timeZone: "America/New_York",
          },
          destinationSic: {
            id: 84,
            code: "AFW",
            ownership: "V",
            lhRegionId: null,
            timeZone: "America/Chicago",
          },
          stops: [],
          notificationType: "TrackedInSameAreaForAtLeastTwoHours",
          readStatus: true,
          createdById: "b0e94ef6-884a-4714-90ab-c61582e2df41",
          createdBy: "Yamuna Kotla",
          createdOn: new Date("2026-02-09T16:39:35.937032Z"),
          modifiedById: null,
          modifiedBy: "",
          modifiedOn: null,
          notificationIcon: "Error",
        },
        {
          id: 279,
          tripNumber: 10027280,
          originSic: {
            id: 174,
            code: "ABE",
            ownership: "V",
            lhRegionId: null,
            timeZone: "America/New_York",
          },
          destinationSic: {
            id: 84,
            code: "AFW",
            ownership: "V",
            lhRegionId: null,
            timeZone: "America/Chicago",
          },
          stops: [],
          notificationType: "MechanicalStatus",
          readStatus: false,
          createdById: "1feeeba1-edcd-49a9-9b55-c5d074f1d1dc",
          createdBy: "Unknown",
          createdOn: new Date("2026-02-09T16:11:10.460054Z"),
          modifiedById: null,
          modifiedBy: "",
          modifiedOn: null,
          notificationIcon: "Build",
        },
        {
          id: 272,
          tripNumber: 10027240,
          originSic: {
            id: 174,
            code: "ABE",
            ownership: "V",
            lhRegionId: null,
            timeZone: "America/New_York",
          },
          destinationSic: {
            id: 194,
            code: "ASA",
            ownership: "C",
            lhRegionId: null,
            timeZone: "America/Chicago",
          },
          stops: [],
          notificationType: "MechanicalStatus",
          readStatus: false,
          createdById: "1feeeba1-edcd-49a9-9b55-c5d074f1d1dc",
          createdBy: "Unknown",
          createdOn: new Date("2026-02-09T13:38:15.959041Z"),
          modifiedById: null,
          modifiedBy: "",
          modifiedOn: null,
          notificationIcon: "Build",
        },
      ],
    },
    totalCount: 8,
    readCount: 2,
    unreadCount: 6,
  };
